import React from 'react';
import { Map, PhoneCall } from 'lucide-react';
import { STORE } from '../config/store';
import { btnAccent, btnXs, containerWide, sectionHeading, sectionSpacing } from '../styles/ui';

const Contact = () => {
  const openMaps = () => {
    window.open(STORE.mapsUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="contact" className={`${sectionSpacing} relative overflow-hidden`}>
      {/* Map Background */}
      <img
        src="/store-map.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover filter blur-sm opacity-30"
      />

      {/* Get Directions Button - Bottom Right */}
      <div className="absolute bottom-8 right-8 z-20">
        <button
          onClick={openMaps}
          className={`${btnAccent} ${btnXs} px-5`}
        >
          <Map size={14} /> Get Directions
        </button>
      </div>

      {/* Content */}
      <div className={`${containerWide} relative z-10`}>
        <div className="max-w-xl">
          {/* Contact Info Column */}
          <h2 className={`${sectionHeading} mb-3`}>Get in Touch</h2>
          <p className="text-gray-700 mb-10">Stop by and explore our fresh collection</p>
          
          <div className="flex flex-col gap-6">
            {/* Our Location */}
            <div className="flex gap-3 items-start group floating-card rounded-2xl p-3 -m-3">
              <div className="shrink-0 group-hover:scale-110 transition-transform mt-1">
                <Map size={18} className="text-emerald-700" />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-base font-semibold text-emerald-950">Our Location</span>
                <address className="text-ink-secondary text-sm leading-relaxed not-italic">
                  {STORE.address}
                </address>
              </div>
            </div>

            {/* Phone Number */}
            <div className="flex gap-3 items-start group floating-card rounded-2xl p-3 -m-3">
              <div className="shrink-0 group-hover:scale-110 transition-transform mt-1">
                <PhoneCall size={18} className="text-emerald-700" />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-base font-semibold text-emerald-950">Phone Number</span>
                <a
                  href={STORE.phoneHref}
                  className="text-emerald-950 font-medium text-sm hover:text-emerald-700 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700 focus-visible:ring-offset-2 rounded w-fit"
                >
                  {STORE.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
